"use client";

import Image from "next/image";
import { Heading } from "@/components/ui/typography";

export default function Cta({ heading = "Built for Remote-First Founders", behindFilingsHeading = "Already behind on filings?" }: { heading?: string; behindFilingsHeading?: string } = {}) {
  return (
    <section className="lg:py-[60px] py-[30px] px-4 min-w-[1340px]:px-0">
      <div className="max-w-[1200px] mx-auto flex flex-col lg:flex-row gap-10 items-center">

        {/* LEFT SIDE */}
        <div className="flex-1 flex flex-col gap-8">

          {/* Heading */}
          <div className="flex flex-col gap-6">
            <Heading as="h2" variant="section">
              {heading}
            </Heading>

            <p className="text-white/70 text-[16px] leading-[24px] font-medium">
              Most MuteTaxes clients operate outside Hong Kong. This allows you to
              outsource HK company compliance without losing visibility into your finances.
            </p>
          </div>

          {/* Pills */}
          <div className="flex flex-col gap-4">

            <div className="flex flex-wrap gap-3">

              {[
                { icon: "/book-icon.svg", text: "Xero / QuickBooks" },
                { icon: "/lock-password-fill.svg", text: "secure document storage" },
              ].map((item, i) => (
                <div
                  key={i}
                  className="flex items-center gap-3 bg-[#0f1218] border border-white/10 px-4 py-2 rounded-full"
                >
                  <Image src={item.icon} alt="" width={19} height={19} className="[filter:brightness(0)_invert(1)]" />
                  <span className="text-white/70 text-[14px] md:text-[16px]">
                    {item.text}
                  </span>
                </div>
              ))}

            </div>

            <div className="flex flex-wrap gap-3">

              {[
                { icon: "/cloud-windy-fill.svg", text: "cloud financial access" },
                { icon: "/whatsapp-fill.svg", text: "WhatsApp support access" },
              ].map((item, i) => (
                <div
                  key={i}
                  className="flex items-center gap-3 bg-[#0f1218] border border-white/10 px-4 py-2 rounded-full"
                >
                  <Image src={item.icon} alt="" width={19} height={19} className="[filter:brightness(0)_invert(1)]" />
                  <span className="text-white/70 text-[14px] md:text-[16px]">
                    {item.text}
                  </span>
                </div>
              ))}

            </div>

          </div>
        </div>

        {/* RIGHT SIDE */}
        <div className="flex-1 relative bg-[#0f1218] border border-white/10 rounded-2xl h-[360px] flex items-center justify-center min-[1200px]:p-0 p-4 w-full">

          <div className=" bg-[#0f1218] border border-white/10 rounded-xl p-6 shadow-md w-full lg:max-w-[536px] max-full">

            <div className="flex flex-col gap-4">

              {/* Title */}
              <div className="flex flex-col gap-2">
                <h3 className="text-white text-[16px] font-semibold">
                  {behindFilingsHeading}
                </h3>

                <p className="text-white text-[14px] opacity-70 leading-[150%]">
                  This is common. Many founders form a Hong Kong company first,
                  then realize compliance requirements later. If your company has:
                </p>
              </div>

              {/* List */}
              <ul className="list-disc pl-5 capitalize text-white text-[14px] leading-[28px]">
                <li>revenue size</li>
                <li>profit level</li>
                <li>activity level</li>
                <li>offshore status</li>
              </ul>

              {/* Extra text */}
              <p className="text-white text-[14px] opacity-70 leading-[150%]">
                This is common. Many founders form a Hong Kong company first,
                then realize compliance requirements later.
              </p>

            </div>
          </div>

        </div>
      </div>
    </section>
  );
}